import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { useSnackbar } from "notistack";
import { connect } from "react-redux";
import { loginUser } from "../../services/user/actions";
import { getSettings } from "../../services/settings/actions";
import { useTranslation } from "react-i18next";

function Login(props) {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [recaptchaVal, setRecaptchaVal] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { t, i18n } = useTranslation();

  useEffect(() => {
    document.title = t("auth_page_title") + " | KPG Partner";
    props?.getSettings();
  }, []);

  const handleLogin = async () => {
    enqueueSnackbar(t("auth_logging_in"), {
      variant: "info",
    });
    props
      ?.loginUser(email, password, recaptchaVal)
      .then((response) => {
        if (response.payload) {
          enqueueSnackbar(t("auth_login_success"), { variant: "success" });
          window.location.href = "/dashboard";
        } else {
          enqueueSnackbar(t("auth_login_failed"), {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        enqueueSnackbar(error.response.data.message, {
          variant: "error",
        });
        console.error("Login error:", error);
      });
  };

  useEffect(() => {
    if (props?.user && props?.user?.auth_token) {
      navigate("/dashboard");
    }
  }, [props?.user]);

  useEffect(() => {
    if (props?.user && props?.user?.auth_token) {
      navigate("/dashboard");
    }
  }, [props]);

  const onRecaptchaChange = (value) => {
    setRecaptchaVal(value);
  };

  const handleSocialLogin = async (provider) => {
    window.location.href = `${SOCIAL_LOGIN_API_URL}/${provider}`;
  };

  return (
    <>
      <div className="login-wrapper">
        <div className="row justify-content-center align-items-center">
          <div className="mt-5 row">
            <div className="text-center">
              <img
                src="/images/kpg-logo.png"
                alt="Logo"
                className="login-logo img-fluid"
              />
            </div>
          </div>

          <div className="login-card card col-xl-3 col-lg-4 col-10 shadow">
            <div className="card-body">
              <div className="row login-header">
                <h5>{t("auth_title")}</h5>
                <span className="text-muted">{t("auth_subtitle")}</span>
              </div>

              <div className="row mt-4">
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    {t("auth_email")}
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    placeholder={t("auth_email_placeholder")}
                    required
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="password" className="form-label">
                    {t("auth_password")}
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    placeholder={t("auth_password_placeholder")}
                    required
                    onChange={(e) => setPassword(e.target.value)}
                  />

                  <span className="text-muted text-end d-block">
                    <a
                      href="/reset-password"
                      className="text-decoration-none text-muted mt-1"
                      style={{ fontSize: "0.8rem" }}
                    >
                      {t("auth_forgot_password")}
                    </a>
                  </span>
                </div>
                <div className="recaptcha-container">
                  {/* <ReCAPTCHA
                    sitekey="6LdOkaYtAAAAAK-UW8BmQ4JKXjRIQH8rakx1sZCa"
                    onChange={onRecaptchaChange}
                    className="g-recaptcha"
                  /> */}
                  <ReCAPTCHA
                    sitekey={"6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"}
                    onChange={onRecaptchaChange}
                    className="g-recaptcha"
                  />
                </div>
                <button
                  onClick={handleLogin}
                  className="btn btn-primary w-100"
                  disabled={!recaptchaVal}
                >
                  {t("auth_login")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  user: state.user.user,
  settings: state.settings.settings,
});

const mapDispatchToProps = {
  loginUser,
  getSettings,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
